const CARTINI = {
  STAGING: {
    WORKPLACE_ID: [860],
    BRAND_ID: [],
    LOGIN_API_URL: 'https://apidev.tire-pick.com/css/signin-cloud-gate',
    SECRET_KEY: 'IOH53SYxdJJgP1x4Pba+xA2iXmIdTEXg',
    IV_KEY: 'vni0tIyqXif9mmmV',
    TAB_NAME: '자사몰',
    IFRAME_URL: 'https://rootdev.tire-pick.com'
  },
  LIVE: {
    WORKPLACE_ID: [1688, 1644, 1643], // 워크플레이스 여러개 에서 아이프레임 노출 원해서 타입 변경
    BRAND_ID: [6990],
    LOGIN_API_URL: 'https://apiprod.tire-pick.com/css/signin-cloud-gate',
    SECRET_KEY: 'xenBvabTSi2flt47BE2bUg9A3Q5gBkZW',
    IV_KEY: 'KJ8Wsuh4EYuW5DkB',
    TAB_NAME: '자사몰',
    IFRAME_URL: 'https://root.tire-pick.com'
  }
};

const FAQ_CUSTOM = {
  AIFAQ_WORKPLACE: [
    { name: 'dev', brands: [269] },
    { name: 'dev2', brands: [269] },
    { name: 'staging', brands: [4, 5, 112, 558, 811] },
    { name: 'production', brands: [1, 4, 176, 256, 907, 970, 1484, 1550, 1643, 1811] }
  ],
  AIFAQ_MENU: {
    title: 'AI 상담 서비스 관리',
    children: [
      {
        title: 'AI FAQ 어시스턴트',
        path: '/brand/aiCounselAssistance',
        accountsTypes: ['OWNER', 'BRAND_MANAGER'],
        pages: [
          {
            title: 'AI FAQ 어시스턴트 수정',
            path: '/brand/aiCounselAssistance/edit',
            accountsTypes: ['OWNER', 'BRAND_MANAGER']
          }
        ]
      }
    ]
  }
};

const AI_CHAT_CUSTOM = {
  MENU: {
    title: 'AI 상담 서비스 관리',
    children: [
      {
        title: 'AI 챗봇 설정',
        path: '/brand/ai_chatbot_setting',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  }
};

const NEOPHARM_CUSTOM = {
  NEOPHARM_WORKPLACE: [
    { name: 'dev', brands: [] },
    { name: 'dev2', brands: [5330, 5161, 6024] },
    { name: 'staging', brands: [5639, 6615] }, // 6058 온프레1
    // 클라우드게이트 - 클라우드게이트(4), AI 테스트(7656)
    // 네오팜 - 카카오톡(8026), 기타(단종)(8027), 더마비(8021), 리얼베리어(8019), 써지엔젤(8025), 쏘렉스(8024), 콜(7921), 제로이드(8020), 티엘스(8022), 포앤팜(8023), 네오랩(8032), 더마트로지(8033), 에이토솔루션(8034), 아토팜게시판(8044), 힐러웨이브 (8074), 공통 (8075)
    { name: 'production', brands: [4, 7656, 8026, 8027, 8021, 8019, 8025, 8024, 7921, 8020, 8022, 8023, 8032, 8033, 8034, 8044, 8074, 8075] }
  ],
  MENU: {
    title: '상품/구입처 관리',
    children: [
      {
        title: '상품',
        path: '/product_and_supplier_management/product',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      },
      {
        title: '구입처',
        path: '/product_and_supplier_management/supplier',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  }
};

const ADAPTER_CUSTOM = {
  WORKPLACE: [
    { name: 'dev', brands: [] },
    { name: 'dev2', brands: [] },
    { name: 'staging', brands: [6738, 6739] }, // 6059 온프레2
    {
      name: 'production',
      brands: [
        7882, 7890, 7891, 7893, 7912, 7913, 7914, 7915, 7916, 7917, 7923, 7924, 7925, 7926, 7927, 7928, 7929, 7930, 7931, 7932, 7933, 7934, 7935,
        7936, 7937, 7938, 7944
      ]
    }
  ],
  MENU: {
    title: '상품 관리',
    children: [
      {
        title: '상품',
        path: '/product_and_supplier_management/product',
        accountsTypes: ['OWNER', 'BRAND_MANAGER']
      }
    ]
  }
};

const KIA_FLEX = {
  DEV2: {
    WORKPLACE_ID: [406] // 온프레미스단일
  },
  STAGING: {
    WORKPLACE_ID: [558] // STAG_CALL
    // WORKPLACE_ID: [558, 811] // STAG_CALL, 온프레멀티
  },
  LIVE: {
    WORKPLACE_ID: [1295, 256] // 기아플렉스, CGOMNI
  }
};

const OPEN_MILE = {
  DEV2: {
    TEL_NUMBER: ['5012']
  },
  LIVE: {
    TEL_NUMBER: [
      '6532',
      '6533',
      '6534',
      '6535',
      '6536',
      '6537',
      '6538',
      '6539',
      '6540',
      '6541',
      '6542',
      '6543',
      '6544',
      '6545',
      '6546',
      '6547',
      '6548',
      '6549',
      '6550',
      '6561',
      '6562',
      '6563',
      '6564',
      '6566',
      '6567',
      '6568'
    ]
  }
};

const isProduction = process.env.NODE_ENV === 'production' && process.env.ENV_TARGET !== 'staging';

const getCartiniWorkplaceId = () => {
  if (!(process.env.ENV_TARGET === 'staging' || process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'production')) {
    return [];
  }
  return isProduction ? CARTINI.LIVE.WORKPLACE_ID : CARTINI.STAGING.WORKPLACE_ID;
};

const getLoginApiUrl = () => {
  return isProduction ? CARTINI.LIVE.LOGIN_API_URL : CARTINI.STAGING.LOGIN_API_URL;
};

const getSecretKey = () => {
  return isProduction ? CARTINI.LIVE.SECRET_KEY : CARTINI.STAGING.SECRET_KEY;
};

const getIvKey = () => {
  return isProduction ? CARTINI.LIVE.IV_KEY : CARTINI.STAGING.IV_KEY;
};

const getCartiniTabName = () => {
  return isProduction ? CARTINI.LIVE.TAB_NAME : CARTINI.STAGING.TAB_NAME;
};

const getIframeURL = () => {
  return isProduction ? CARTINI.LIVE.IFRAME_URL : CARTINI.STAGING.IFRAME_URL;
};

const getFaqEnableList = () => {
  return FAQ_CUSTOM.AIFAQ_WORKPLACE.find((data) => data.name === process.env.NODE_ENV);
};

const getFaqMenu = () => {
  return FAQ_CUSTOM.AIFAQ_MENU;
};

const getAIChatbotMenu = () => {
  return AI_CHAT_CUSTOM.MENU;
};

const getKiaFlexInfo = (key) => {
  let value = [];
  if (key === 'WORKPLACE_ID') {
    switch (process.env.NODE_ENV) {
      case 'dev2':
        value = KIA_FLEX.DEV2.WORKPLACE_ID;
        break;
      case 'staging':
        value = KIA_FLEX.STAGING.WORKPLACE_ID;
        break;
      case 'production':
        value = KIA_FLEX.LIVE.WORKPLACE_ID;
        break;
    }
  }

  return value;
};

/*
 * 오픈마일 재택근무 상담사 내선번호 목록
 */
const getOpenMileRemoteAgentTelNumberList = () => {
  let value = [];
  switch (process.env.NODE_ENV) {
    case 'dev2':
      value = OPEN_MILE.DEV2.TEL_NUMBER;
      break;
    case 'production':
      value = OPEN_MILE.LIVE.TEL_NUMBER;
      break;
  }

  return value;
};

const getDownloadReasonList = (workplaceId) => {
  // 워크플레이스 기준 라이브서버: 카카오헬스케어 / 스테이징서버: 온프레멀티 / ... 그외 서버 고려안함
  const useETC = isProduction ? [1635].indexOf(workplaceId) === -1 : [811].indexOf(workplaceId) === -1;
  return useETC ? ['일일 보고용', '주간 보고용', '설문용', '확인용', '검수용', '기타'] : ['일일 보고용', '주간 보고용', '설문용', '확인용', '검수용'];
};

const getShowGroupChatWorkplace = (workplaceId) => {
  if (!workplaceId) {
    return false;
  }
  // 스테이징용
  if (!isProduction) {
    return true;
  }

  // 실서버용
  return true;
};

const getGroupChatDomain = () => {
  // 스테이징용
  if (!isProduction) {
    return 'https://stg-grchat-web.thecloudgate.io';
  }

  return 'https://grchat-web.thecloudgate.io';
};

const getKurlyTicketCustomBrandIds = () => {
  return isProduction ? [7800, 4] : [4, 6127, 6128, 6058, 6059, 6060, 6061, 6484, 6485, 6828]; // 6127 단일브랜드, 6058 온프레1..., 테스트테스트
}; // 컬리 티켓 커스텀 (스마트스토어) 브랜드 아이디 배열

const getKurlySmartStoreCustom = () => {
  return isProduction ? [1977, 4] : [4, 916, 315]; // 클라우드게이트, kurlyTest2, CGOMNI
};

const getNeoPharmCustomEnableList = () => {
  return NEOPHARM_CUSTOM.NEOPHARM_WORKPLACE.find((data) => data.name === process.env.NODE_ENV);
};

const getNeoPharmMenu = () => {
  return NEOPHARM_CUSTOM.MENU;
};

const getAdapterCustomEnableList = () => {
  return ADAPTER_CUSTOM.WORKPLACE.find((data) => data.name === process.env.NODE_ENV);
};

const getAdapterMenu = () => {
  return ADAPTER_CUSTOM.MENU;
};

export {
  getCartiniWorkplaceId,
  getLoginApiUrl,
  getSecretKey,
  getIvKey,
  getCartiniTabName,
  getIframeURL,
  getFaqEnableList,
  getFaqMenu,
  getKiaFlexInfo,
  getOpenMileRemoteAgentTelNumberList,
  getDownloadReasonList,
  getAIChatbotMenu,
  getShowGroupChatWorkplace,
  getGroupChatDomain,
  getKurlyTicketCustomBrandIds,
  getNeoPharmCustomEnableList,
  getNeoPharmMenu,
  getAdapterMenu,
  getAdapterCustomEnableList,
  getKurlySmartStoreCustom
};



// WEBPACK FOOTER //
// ./src/constants/customInfo.js